import { ProfileDto } from '@app/models/dtos/contentDto';
import cn from 'classnames';
import React from 'react';

interface ILayoutProps {
    className?: string;
    profile: ProfileDto;
    /** Small link shown opposite the name at the top of the page. */
    topRight?: React.ReactNode;
}

/** No chrome: one column, one surface. The top row sits in the flow and scrolls away. */
export default function Layout({ children, className, profile, topRight }: React.PropsWithChildren<ILayoutProps>) {
    return (
        <div className="min-h-screen bg-paper text-ink">
            <div className={cn('mx-auto w-full max-w-[680px] px-6 pb-24 pt-14 md:pt-20', className)}>
                <div className="mb-16 flex items-baseline justify-between gap-6 md:mb-24">
                    <p className="t-label text-muted">{profile.name}</p>
                    {topRight}
                </div>

                {children}

                <div className="rule mb-10 mt-16 md:mt-24" aria-hidden="true" />
                <p className="t-small text-muted">
                    © {new Date().getFullYear()} {profile.name} · {profile.location}
                </p>
            </div>
        </div>
    );
}
